import styled, { css } from "styled-components";
import getColor from "../../../utils/getColor";
import getIconColor from "../../../utils/getIconColor";
import getTextColor from "../../../utils/getTextColor";
import space from "../../../utils/space";
import Link from "../../quarks/Link";
import { cssTextAtm } from "../TextAtm/TextAtm.styled";
export var StyledIconLinkAtm = styled(Link).withConfig({
  componentId: "sc-1fb7kq6-0"
})(function (_ref) {
  var $emphasis = _ref.$emphasis,
    $hasText = _ref.$hasText,
    $textEmphasis = _ref.$textEmphasis,
    $textHoverColor = _ref.$textHoverColor,
    $iconHoverColor = _ref.$iconHoverColor,
    $iconAlign = _ref.$iconAlign,
    $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["display:inline-flex;cursor:pointer;&:hover *{fill:", ";color:", ";}", ""], $iconHoverColor ? getColor(theme, $iconHoverColor) : getIconColor(theme, $onColor, $emphasis, "hover"), $textHoverColor ? getColor(theme, $textHoverColor) : getTextColor(theme, $onColor, $textEmphasis, "hover"), $hasText && css(["align-items:", ";text-decoration:none;"], $iconAlign));
});
export var Text = styled.p.withConfig({
  componentId: "sc-1fb7kq6-1"
})(function (_ref2) {
  var $typography = _ref2.$typography,
    $textEmphasis = _ref2.$textEmphasis,
    $gutterSpace = _ref2.$gutterSpace,
    $iconPosition = _ref2.$iconPosition,
    $onColor = _ref2.$onColor,
    $color = _ref2.$color;
  return css(["", ";", " ", ""], cssTextAtm({
    typography: $typography,
    onColor: $onColor,
    emphasis: $textEmphasis,
    color: $color
  }), $iconPosition === "right" && css(["margin-right:", ";"], space($gutterSpace)), $iconPosition === "left" && css(["order:1;margin-left:", ";"], space($gutterSpace)));
});